// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"a18cfdf4","167":"52838dad","341":"5b749fcf","420":"76a47613","465":"265727da","491":"61c0a2d9","714":"ee5deee0","960":"c55deb3f"}[chunkId] + ".chunk.js";
};